import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";

import { db, auth } from "../../../../firebase";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

import PageHeading from "../../../../components/common/PageHeading";
import {
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  Checkbox,
  Radio,
  Space,
  DatePicker,
} from "antd";
import {
  salutations,
  vendorType,
  sendingPref,
  consolidateChecks,
  vendorTradType,
  defaultGLAccount,
} from "../../../../utils/Util";
import { ArrowLeftOutlined } from "@ant-design/icons";
import PhoneNumbers from "../../Owners/NewOwner/Components/PhoneNumbers";
import Emails from "../../../Leasing/RentalApplications/Components/Emails";

import PaymentAddress from "../../Owners/NewOwner/Components/PaymentAddress";
import FormAction from "../../../../components/common/FormAction";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import { createNewVender } from "../VendorFirbase";
import VendorAddresses from "./components/VendorAddresses";
import { toast } from "react-hot-toast";
import { tradeList } from "../vendersData";

const { Option } = Select;
function NewVendor() {
  const [vendorAddress, setvendorAddress] = useState(false);
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(false);

  const [isWait, setIsWait] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [useOnlinePayables, setUseOnlinePayables] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [userName, setUserame] = useState("");
  const [notes, setNotes] = useState([]);
  const [fileList, setFileList] = useState([]);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setCompanyName(res.companyName);
            setUserame(res.firstName);
            console.log(res.firstName);
            console.log(res);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  // const pull_Attachments = (data) => {
  //   console.log("newFileList",data);
  // }

  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: 1, phoneNumber: "", type: "", additionalDetails: "" },
  ]);

  const [emails, setEmails] = useState([{ id: 1, email: "" }]);

  const [vendorAddresses, setVendorAddresses] = useState([
    { id: 1, addressOne: "", addressTwo: "", city: "", state: "", country: "" },
  ]);

  const [files, setFiles] = useState([]);

  const onFinish = async (values) => {
    setIsWait(true);
    console.log("Success:", values);
    const usersRef = collection(db, "allUsers");

    const phNumber = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const mails = emails.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const addresses = vendorAddresses.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });
    const vendorNotes = notes.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    try {
      const querySnapshot = await getDocs(
        query(usersRef, where("email", "==", values.email0))
      );

      if (querySnapshot.size > 0) {
        toast.error(`${values.email0} email already taken.`);
        setErrorMessage(true);
      } else {
        createNewVender(
          values,
          companyName,
          phNumber,
          mails,
          addresses,
          vendorNotes,
          files
        ).then(() => {
          toast.success("Vendor created successfully", 4);
          
            navigate("/people/vendors");
            setIsWait(false);
          
        });
      }
    } catch (error) {
      const errorMessage = error.message;

      toast.error(errorMessage);
      console.log("Error", error);
      setIsWait(false);
    }
  };
  // Reset the form values when the "cancel" button is clicked
  const handleCancel = () => {
    navigate("/people/vendors");
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    toast.error("Please fill in all the required fields!", 3);
    const getNotes = JSON.parse(localStorage.getItem("notes"));

    console.log("Notes");
    console.log(...getNotes);
    console.log("Notes");
    setIsWait(false);
  };
  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };
  const options = [
    { value: "cartpet cleaning", label: "chimny cleaning" },
    { value: "dreanage", label: "dreanage" },
    { value: "chimny cleaning", label: "dreanage" },
  ];

  useEffect(() => {
    fetchCompanyName();
  }, []);
  return (
    <>
      <PageHeading heading="New Vendor" />

      <Form
        name="basic"
        labelCol={{ span: 7 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="form-container"
        colon={false}
      >
        <Row>
          <Col span={24}>
            {/* Vendor Information */}
            <Card title="Vendor  Information" bordered={false}>
              <Form.Item
                label="Salutation"
                name="salutation"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please Select any salutation!",
                //   },
                // ]}
              >
                <Select options={salutations} />
              </Form.Item>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please input your First Name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Last Name"
                rules={[
                  {
                    required: true,
                    message: "Please input your Last Name!",
                  },
                ]}
                name="lastName"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Company Name"
                name="companyName"
                rules={[
                  {
                    required: true,
                    message: "Please input your Company Name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Use company name as display name"
                name="useCompanyName"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              <Form.Item label="Website" name="websiteLink">
                <Input />
              </Form.Item>
              <Form.Item label="Vendor Type" name="vendorType">
                <Select options={vendorType} />
              </Form.Item>
              <Form.Item label="Vendor Trade" name="venderTrade">
                <Select
                  options={tradeList}
                  placeholder="Search by trade"
                />
              </Form.Item>
              <Form.Item
                label="Tags"
                name="tags"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please input one or more than one tag!",
                //   },
                // ]}
              >
                <Select
                  mode="tags"
                  style={{
                    width: "100%",
                  }}
                  tokenSeparators={[","]}
                  options={options}
                />
              </Form.Item>
              {/* <Form.Item label=" ">
                <Button type="link" style={{ padding: 0 }}>
                  Manage Tags
                </Button>
              </Form.Item> */}

              <Form.Item
                label="Do Not Use Vendor for Work Orders"
                name="isVendorUseForWorkOrder"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
            </Card>
            <br />
            {/* Contact */}
            <Card title="Contact" bordered={false}>
              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Phone Numbers</h4>

              <PhoneNumbers
                phoneNumbers={phoneNumbers}
                setPhoneNumbers={setPhoneNumbers}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Emails</h4>

              <Emails
                errorMessage={errorMessage}
                emails={emails}
                setEmails={setEmails}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>Addresses</h4>

              <VendorAddresses
                vendorAddresses={vendorAddresses}
                setVendorAddresses={setVendorAddresses}
              />

              <h4 style={{ fontSize: 13, marginBottom: 20 }}>1099 Address</h4>

              <Form.Item label=" ">
                <Checkbox
                  checked={vendorAddress}
                  onClick={() => setvendorAddress(!vendorAddress)}
                >
                  Use vendor address as 1099 address
                </Checkbox>
              </Form.Item>

              {!vendorAddress ? <PaymentAddress type="vendor" /> : <></>}
            </Card>
            <br />
            {/* Federal Tax */}
            <Card title="Federal Tax" bordered={false}>
              <Form.Item
                label="Taxpayer Name"
                wrappercol={{ span: 8 }}
                name="taxPayerName"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Use company name as taxpayer name"
                name="comapnyTaxpayer"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              <Form.Item
                label="Taxpayer ID"
                wrapperCol={{ span: 8 }}
                name="taxPayerId"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Send 1099?"
                name="send1099"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
            </Card>
            <br />
            {/* Accounting Information*/}
            <Card title="Accounting Information" bordered={false}>
              <Form.Item
                label="Consolidate Checks"
                wrapperCol={{ span: 8 }}
                name="consolidateChecks"
              >
                <Select>
                  {consolidateChecks.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Hold Payments"
                name="holdPayments"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              <Form.Item
                label="Email eCheck Receipt?"
                name="checkEmailReceipt"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>

              {/* TODO: create a modal for last option of payment terms */}
              <Form.Item
                label="Payment Terms"
                name="paymentTerms"
                wrapperCol={{ span: 8 }}
              >
                <Select>
                  {sendingPref.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Default Check Memo"
                wrapperCol={{ span: 8 }}
                name="defaultCheckMemo"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Default GL Account"
                wrapperCol={{ span: 8 }}
                name="defaultGLAccount"
              >
                <Select>
                  {defaultGLAccount.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Default GL Account"
                wrapperCol={{ span: 8 }}
                name="defaultGLAccount"
              >
                <Select options={sendingPref} />
              </Form.Item>

              <Form.Item
                label="Work Order Adjustment"
                name="workOrderAdjustment"
                wrapperCol={{ span: 8 }}
                rules={[
                  {
                    message: "must be less than or equal to 100",
                  },
                  {
                    pattern: /^(100(\.0{1,2})?|\d{0,2}(\.\d{1,2})?)%?$/,
                    message:
                      "Please enter a valid percentage less than or equal to 100%",
                  },
                ]}
              >
                <Input suffix="%" />
              </Form.Item>

              <Form.Item
                label="Adjustment Type"
                wrapperCol={{ span: 8 }}
                name="adjustmentType"
              >
                <Radio.Group>
                  <Radio value="Discount">Discount</Radio>
                  <Radio value="Markup">Markup</Radio>
                </Radio.Group>
              </Form.Item>
            </Card>
            <br />
            {/* Online Payables */}
            <Card title="Online Payables" bordered={false}>
              <Form.Item
                label="Use Online Payables"
                name="useOnlinePayables"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={() => setUseOnlinePayables(!useOnlinePayables)}
                />
              </Form.Item>

              {useOnlinePayables ? (
                <>
                  <Form.Item
                    label="Payment Method"
                    wrapperCol={{ span: 8 }}
                    name="paymentMethod"
                  >
                    <Radio.Group
                      style={{ marginTop: 6 }}
                      onChange={handlePaymentMethodChange}
                      value={paymentMethod}
                    >
                      <Space direction="vertical">
                        <Radio value="billPay">Bill Pay</Radio>
                        <Radio value="eCheck">eCheck</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item
                    label="Vendor Bank Routing Number"
                    name="vendorBankRoutingNumber"
                    wrapperCol={{ span: 8 }}
                  >
                    <Input disabled={paymentMethod === "billPay"} />
                  </Form.Item>

                  <Form.Item
                    label="Vendor Bank Account Number"
                    name="vendorAccountNumber"
                    wrapperCol={{ span: 8 }}
                  >
                    <Input disabled={paymentMethod === "billPay"} />
                  </Form.Item>

                  <Form.Item
                    label="Saving Account?"
                    name="savingAccount"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                </>
              ) : (
                <></>
              )}
            </Card>
            <br />
            {/* Compliance */}
            <Card title="Compliance" bordered={false}>
              <Form.Item
                label="Workers' Comp. Expiration"
                name="workerCompExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>

              <Form.Item
                label="Liability Insurance Expiration"
                name="liabilityInsuranceExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>

              <Form.Item
                label="EPA Certification Expiration"
                name="EPACertificationExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>

              <Form.Item
                label="Auto Insurance Expiration"
                name="autoInsuranceExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>

              <Form.Item
                label="State License Expiration"
                name="stateLicenseExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>

              <Form.Item
                label="Contract Expiration"
                name="contractExpiration"
                wrapperCol={{ span: 8 }}
              >
                <DatePicker style={{ width: "100%" }} format="MM-DD-YYYY" />
              </Form.Item>
            </Card>
            <br />
            {companyName ? (
              <Notes
                notesForCollection="vendors"
                notesForCollectionId=""
                companyName={companyName}
                notes={notes}
                setNotes={setNotes}
              />
            ) : null}
            <br />
            <AttachmentsUpload setFiles={setFiles} />
            <br />
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" loading={isWait}>
                  {isWait ? "please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button onClick={handleCancel}>Cancel</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <div className="RightSidebar"></div>
    </>
  );
}

export default NewVendor;
